/**
 * pages/wallet/WalletPage.tsx — UPDATED
 *
 * Phase 6 changes:
 *   - WalletActions now includes "Bank Deposit" and "Bank Withdraw"
 *   - Added manual deposits summary list below transactions
 *   - No import changes needed if options.ts WalletActions is updated
 *
 * REPLACE your existing pages/wallet/WalletPage.tsx with this file.
 */

import { WalletIcon } from "../../../assets/svg/Svgs";
import {
  MANUAL_DEPOSITS,
  MANUAL_WITHDRAWALS,
  TRANSACTIONS,
  WALLET,
} from "../../../constants/constants";
import { WalletActions } from "../../../constants/options";
import { useTitle } from "../../../hooks/common/useTitle";
import { IsInvestor, IsBorrower } from "../../../utils/permissionUtils";
import { QuickActions } from "../../common/QuickActions";
import { AnimateChildren } from "../../elements/Elements";
import { ListHandler } from "../../lists/ListHandler";
import { BalanceCard } from "./BalanceCard";
import { InvestorBalanceCard } from "./InvestorBalanceCard";
import { WalletCard } from "./WalletCard";

export const WalletPage = () => {
  useTitle(WALLET);

  return (
    <div className="container1">
      <div className="p15 flexColumn gap15">
        <AnimateChildren>
          <BalanceCard light icon={WalletIcon} />
          <WalletCard />
          <QuickActions actions={WalletActions()} />

          {IsInvestor() && <InvestorBalanceCard />}

          <ListHandler
            source={TRANSACTIONS}
            title="Recent Transactions"
            summary
          />

          {/* Manual deposit & withdrawal history */}
          <ListHandler
            source={MANUAL_DEPOSITS}
            title="Manual Deposits"
            summary
          />
          <ListHandler
            source={MANUAL_WITHDRAWALS}
            title="Manual Withdrawals"
            summary
          />
        </AnimateChildren>
      </div>
    </div>
  );
};